let context: CanvasRenderingContext2D | undefined;

function getContext(): CanvasRenderingContext2D {
  if (context) return context;

  const canvas = document.createElement('canvas');
  const ctx = canvas.getContext('2d');
  if (!ctx) throw new Error('Could not create canvas context');

  context = ctx;
  return context;
}

export function measureTextWidth(text: string, font = '16px Arial') {
  const context = getContext();
  context.font = font;
  const metrics = context.measureText(text);
  return metrics.width;
}
